import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getUserId } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login'] // 白名单中的重定向

router.beforeEach(async (to, from, next) => {
    // 启动进度条
    NProgress.start()

    // 设置页面标题
    document.title = getPageTitle(to.meta.title)

    // 确定用户是否已登录
    const hasUserId = getUserId()

    await store.dispatch('getEnvironment')

    const { AK } = store.state

    // if (hasUserId) {
    if (to.path === '/login' || to.path === '/download-app') {
        // 如果已登录，请重定向到主页
        // next({ path: '/' })
        next()
    } else {
        const UserType = localStorage.getItem('UserType')
        // 确定用户是否已通过 getInfo 获得其权限路由
        const hasAddRoutes = store.getters.addRoutes && store.getters.addRoutes.length > 0
        if (hasAddRoutes) {
            if (from.query.AK && !to.query.AK) {
                next({
                    ...to,
                    replace: true,
                    query: {
                        ...to.query,
                        AK: from.query.AK,
                        cpuId: from.query.cpuId,
                    }
                })
            } else {
                next()
            }
        } else {
            try {
                // 基于权限路由生成可访问的路由
                let routes = []
                let userInfo = {}
                // 获取用户信息
                if (UserType === 'enterprise' || AK) {
                    // 企业用户需要动态添加路由
                    userInfo = await store.dispatch('user/getInfo')
                }

                if (UserType === 'enterprise') {
                    routes = userInfo.routes || []
                    routes.unshift({
                        path: '/',
                        component: '@/layout',
                        redirect: '/home',
                        children: [
                            {
                                path: 'home',
                                component: '@/views/home/index',
                                name: 'Home',
                                meta: { title: 'dashboard', icon: 'el-icon-s-home' }
                            }
                        ]
                    })
                } else {
                    // 普通用户首页为地面站页面
                    routes.push({
                        path: '/',
                        redirect: '/tta',
                        hidden: true
                    })
                }

                routes.push({
                    path: '/tta',
                    name: 'tta',
                    hidden: true,
                    component: '@/views/tta'
                })
                const accessRoutes = await store.dispatch('permission/generateRoutes', routes)

                // 动态添加可访问的路由
                router.addRoutes(accessRoutes)
                // hack方法以确保addRoutes是完整的
                // 设置replace:true，这样导航将不会留下历史记录
                next({ ...to, replace: true })
            } catch (error) {
                // 删除令牌并转到登录页面重新登录
                await store.dispatch('user/resetToken')
                Message.error(error || 'Has Error')
                next(`/login?redirect=${to.fullPath}`)
                NProgress.done()
            }
        }
    }
    /* } else {
        // 没有登陆
        if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单中，直接进入
            next()
        } else {
            // 没有访问权限的其他页面将重定向到登录页面。
            next(`/login?redirect=${to.fullPath}`)
            NProgress.done()
        }
    } */


    // 设置网站图标
    store.dispatch('user/setIcon')
})

router.afterEach((to, from, next) => {
    // 完成进度条
    NProgress.done()

    const { path } = to;
    if (path === '/login' || path === '/') {
        // 清除登录心跳
        if (window.$globalWs) {
            window.$closeGlobalWs();
        }
    } else {
        // 建立登录心跳
        if (!window.$globalWs) {
            window.$openGlobalWs();
        }
    }
})
